module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "book"
  }, [_c('div', {
    staticClass: "coverInfo"
  }, [_c('img', {
    staticClass: "coverImage",
    attrs: {
      "src": "//textcafe.co/books/IWizHL/tc-custom/9780802193193.jpg?1703426607218",
      "alt": "This image is the cover for the book Crush"
    }
  })]), _vm._v(" "), _c('div', {
    staticClass: "bookInfo"
  }, [_c('h1', {
    staticClass: "bookTitle heading font1"
  }, [_vm._v("Crush\n    ")]), _vm._v(" "), _c('p', {
    staticClass: "bookDescription body article font2"
  }, [_c('b', [_vm._v("This debut novel of a Frenchwoman’s obsessive affair is ")]), _c('b', [_vm._v("“a little book that astonishes, by the fierceness of its outlook, the rawness of its tone” ("), _c('i', [_vm._v("Magazine Littéraire")]), _vm._v(").")]), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Amélie is a thirty-year-old haute bourgeoisie wife of a distant husband and mother of two picture-perfect daughters. One evening at a service station on the outskirts of the Bois de Boulogne, she meets a man named David and immediately steps into a new life of erotic sensuality. Twenty years her senior, darkly handsome, and almost embarrassingly virile, he is a suave filmmaker, a confirmed bachelor, and the perfect match for the perfect affair—but one with a twist."), _c('br'), _vm._v(" "), _c('br'), _vm._v(" Amélie is not the typical lonely wife, starving for affection. Capricious, snobbish, and sometimes deceitful, she is ravenously hungry for pleasure. Written with cool-headed intensity and sexual heat, "), _c('i', [_vm._v("Crush")]), _vm._v(" is an unforgettable odyssey through the wilds of desire into the badlands of erotic obsession.\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "authorInfo"
  }, [_c('h2', {
    staticClass: "authorName heading font1"
  }, [_vm._v("\n      Cécile de La Baume, Ramona Desfleurs\n    ")])]), _vm._v(" "), _c('div', {
    staticClass: "publisherInfo"
  }, [_c('h2', {
    staticClass: "publisherName heading font1"
  }, [_vm._v("\n    Grove/Atlantic, Inc.\n   ")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-638a3f51","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/home.vue
// module id = 51
// module chunks = 0